import Layout from "@/layout/index.layout";
import PublicPage from "@/layout/public.layout";
import CallbackPage from "@/pages/auth/callback.page";
import LoginPage from "@/pages/auth/login.page";
import RegisterPage from "@/pages/auth/register.page";
import { VerifyPage } from "@/pages/auth/verify.page";
import HomePage from "@/pages/home/home.page";
import { OrganizationPage } from "@/pages/organization/organization.page";
import SettingsPage from "@/pages/settings/settings.page";
import StripeCallbackPage from "@/pages/stripe/callback.page";
import UsersPage from "@/pages/users/users.page";
import LoadingPage from "@/pages/utils/loading.page";
import NotFoundPage from "@/pages/utils/not-found.page";
import { Suspense } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { ProductsPage } from "@/pages/products/products.page";
import { OneProductPage } from "@/pages/products/one-product.page";

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const Router = () => {
  return (
    <SentryRoutes>
      {/* Private */}
      <Route element={<Layout />}>
        <Route path="products" element={<ProductsPage />} />
        <Route
          path="products/:code"
          element={
            <Suspense>
              <OneProductPage />
            </Suspense>
          }
        />
        <Route path="users" element={<UsersPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="stripe">
          <Route path="callback" element={<StripeCallbackPage />} />
        </Route>
        <Route path="organization" element={<OrganizationPage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<NotFoundPage />}></Route>
      </Route>

      {/* Public */}
      <Route
        element={
          <section className="w-full h-full">
            <PublicPage>
              <Outlet></Outlet>
            </PublicPage>
          </section>
        }
      >
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<RegisterPage />} />
        <Route path="callback" element={<CallbackPage />} />
        <Route path="loading" element={<LoadingPage />} />
        <Route path="/register/verify" element={<VerifyPage />}></Route>
      </Route>
    </SentryRoutes>
  );
};

export default Router;
